import axios from "axios"
import { BASE_URL } from "./appConst"
import axiosAuthRefresh from "axios-auth-refresh";


export const signup = async(values) => {

  const userData = {
    email: values.email,
    password: values.password,
  }

  const session = await axios.post(`${BASE_URL}/sign-up`, userData);

  return session.data;

};

export const login = async(values) => {
  const session = await axios.post(`${BASE_URL}/login`, 
    {
      email: values.email,
      password: values.password,
    }
  );

  return session.data;
};

export const axiosAuth = () => {
  const token = localStorage.getItem("token");

  const axiosInstance = axios.create({
    baseURL: BASE_URL,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  // Function to refresh token
  const refreshtoken = localStorage.getItem("refreshToken");

  const refreshAuthLogic = (failedRequest) =>
    axios
      .post(`${BASE_URL}/refresh-token`, {
        refreshtoken: refreshtoken,
      })
      .then((response) => {
        const newToken = response.data.data.response.AccessToken;
        localStorage.setItem("token", newToken);
        failedRequest.response.config.headers[
          "Authorization"
        ] = `Bearer ${newToken}`;
        return Promise.resolve();
      });

  axiosAuthRefresh(axiosInstance, refreshAuthLogic);

  return axiosInstance;
};

export const doctorAxiosAuth = () => {
  const token = localStorage.getItem("doctorAccessToken");

  const axiosInstance = axios.create({
    baseURL: BASE_URL,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  return axiosInstance;
};

export const forgotPassword = async (email) => {
  const api = axiosAuth();

  const response = await api.post(`${BASE_URL}/forget-password`, 
    {
      email: email,
    });

  return response.data;
}

export const resetPassword = async ( email, confirmationCode, newPassword ) => {
  const api = axiosAuth();

  const response = await api.post(`${BASE_URL}/reset-password`, {
    email: email,
    confirmationCode: confirmationCode,
    newPassword: newPassword,
  });

  return response.data;
};


// doctor signup
export const doctorSignup = async (values) => {

  const response = await axios.post(`${BASE_URL}/doctor/signup`, {
    email: values.email,
    password: values.password,
  });

  return response.data;
};

// doctor login
export const doctorLogin = async (values) => {

  const response = await axios.post(`${BASE_URL}/doctor/login`, {
    email: values.email,
    password: values.password,
  });

  const doctorToken = response.data.data.response.AccessToken;
  localStorage.setItem("doctorAccessToken", doctorToken);

  return response.data;
};